import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// Initialize Application Insights
const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING || '',
        enableAutoRouteTracking: false, // We'll track manually with RouteTracker
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        disableFetchTracking: false,
        disableAjaxTracking: false,
    }
});

// Only initialize if connection string is provided
if (process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING) {
    appInsights.loadAppInsights();
    console.log('Application Insights initialized');
} else {
    console.warn('Application Insights connection string not found. Telemetry disabled.');
}

/**
 * Track a custom event with additional properties
 * @param {string} name - Event name
 * @param {Object} [properties] - Additional properties to track
 */
export function trackEvent(name, properties) {
    appInsights.trackEvent({ name }, properties);
}

/**
 * Set user context for session tracking
 * @param {string} userId - Unique user identifier (e.g., email or ID)
 * @param {'Internal' | 'External' | 'Unauthorized'} audience - User audience type
 */
export function setUserContext(userId, audience) {
    appInsights.setAuthenticatedUserContext(userId, undefined, true);
    
    // Add custom properties to all telemetry
    appInsights.addTelemetryInitializer((envelope) => {
        if (envelope.data) {
            envelope.data.audience = audience;
            envelope.data.appType = 'RetirementForecaster';
        }
    });

    // Track session start with audience
    trackEvent('SessionStart', {
        audience: audience,
        userId: userId,
        timestamp: new Date().toISOString()
    });
}

/**
 * Clear user context (on logout or when leaving)
 */
export function clearUserContext() {
    appInsights.clearAuthenticatedUserContext();
}

/**
 * Track page view manually if needed
 * @param {string} [name] - Page name
 * @param {string} [uri] - Page URI
 */
export function trackPageView(name, uri) {
    appInsights.trackPageView({ name, uri });
}

export { appInsights };